export default "__VITE_ASSET__DFKCYdCM__$_?nuxt_component=async&nuxt_component_name=Svgo头像&nuxt_component_export=default__"